import { MODAL_DOMAIN } from 'modules/modal/constants/index.cjs'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'

/**
 * Resets the DomainNew to null.
 * @returns {Function}
 */
function closeModalAction () {
  return (dispatch) => {
    const path = MODAL_DOMAIN
    const value = {
      current: null,
      data: null
    }
    dispatch(
      updateLegacyReduxAction({
        path,
        value
      })
    )
  }
}

export default closeModalAction
